var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:['text-capitalize border-btn', {'fixed': _vm.fixed}],attrs:{"rounded":"","depressed":"","color":"#F9F9F9","small":""},on:{"click":_vm.onBackClick}},[_c('v-icon',{attrs:{"color":"accent","left":""}},[_vm._v("$left_arrow")]),_c('span',{staticClass:"text-btn"},[_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }